// Copyright (c) Bentley Systems
export enum IntegrationProjectStage {
  Development = 10,
  Preview = 20,
  Current = 30,
  Obsolete = 40,
}
